"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var useForceUpdate_1 = require("./useForceUpdate");
var context_1 = __importDefault(require("../context"));
exports.useFormState = function (defaultState) {
    var forceUpdate = useForceUpdate_1.useForceUpdate();
    var ref = react_1.useRef({});
    var form = react_1.useContext(context_1.default);
    ref.current.subscribeId = react_1.useMemo(function () {
        form.setFormState(function (state) {
            Object.assign(state, defaultState);
        });
        return form.subscribe(function (_a) {
            var type = _a.type;
            if (type === core_1.LifeCycleTypes.ON_FORM_CHANGE) {
                forceUpdate();
            }
        });
    }, []);
    ref.current.state = form.getFormState();
    react_1.useEffect(function () {
        return function () {
            form.unsubscribe(ref.current.subscribeId);
        };
    }, []);
    return [
        ref.current.state,
        function (nextState) {
            if (!nextState)
                return;
            form.setFormState(function (state) {
                Object.assign(state, nextState);
            });
        }
    ];
};
